import React from 'react';
import { MdSpeed } from 'react-icons/md';

import PropTypes from 'prop-types';

import InfoCard from '~/components/InfoCard';
import LocaleMessage from '~/components/LocaleMessage';

import { getAverageEfficiency, formatEfficiency } from './EfficiencyUtils';

export default function EfficiencyInfoCard({ list, color }) {
    const avgEfficiency = getAverageEfficiency(list);

    return (
        <div className="col-md-3 col-12 dash-card mb-3">
            <InfoCard
                data={{
                    title: formatEfficiency(avgEfficiency),
                    subTitle: (
                        <span>
                            <LocaleMessage msg="page.robots.cleaning_report.metrics.efficiency.avg" />
                        </span>
                    ),
                }}
                color={color}
                Icon={MdSpeed}
            />
        </div>
    );
}

EfficiencyInfoCard.propTypes = {
    list: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    color: PropTypes.string.isRequired,
};
